<p>search-cost works!</p>
